"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";

import styles from "./Forbidden.module.scss";
import ButtonResponsive from "../ui/button-responsive/button-responsive";

export default function Forbidden({ text }: { text?: string }) {
  const router = useRouter();

  return (
    <div className={styles.forbidden}>
      <div>
        <div>
          <h2>¡OH NO!</h2>
          <p> Parece que te perdiste</p>
        </div>
        <Image
          src='/images/avatars/fede-handsup.svg'
          alt='Fede Hands Up'
          width={300}
          height={457}
        />
        {text && <p>{text}</p>}
        <ButtonResponsive click={() => router.replace("/home")} buttonType='primary'>
          REGRESAR
        </ButtonResponsive>
      </div>
    </div>
  );
}
